/**
 * Lobby layout scrolls on `document.body` (`overflow: auto` in index.scss).
 * `#root` uses `overflow: hidden`; `<html id="mainHtmlId">` does not scroll — scroll listeners belong on `window`.
 */
export function subscribeAppViewportScroll(listener: () => void): () => void {
  window.addEventListener('scroll', listener, { passive: true });

  return () => {
    window.removeEventListener('scroll', listener);
  };
}

/** Current vertical scroll offset of the main app viewport. */
export function getAppViewportScrollTop(): number {
  return window.scrollY;
}
